// Оверлей, который имеет смысл не везде (лёд — только в холодных морях).
//
// Район берётся по ЦЕНТРУ кадра (`regionAt`) — тем же правилом, каким легенда
// выбирает шкалу района: рамка в запросе дробила бы решение на каждом сдвиге.
// Список районов слоя едет в каталоге (`LayerCatalogItem.regions`): разложив
// его по витрине, мы получили бы второй список, разъезжающийся с сервером.
import type { LayerCatalogItem } from '../api'

function fits(layer: LayerCatalogItem | undefined, region: string | null): boolean {
  // Район неизвестен (центр вне всех районов, справочник не приехал) или у слоя
  // ограничения нет — показываем: прятать по незнанию значит терять тумблер там,
  // где он нужен.
  if (!layer?.regions || layer.regions.length === 0 || region == null) return true
  return layer.regions.includes(region)
}

/** Слои каталога, уместные в районе кадра. */
export function overlaysForRegion(layers: LayerCatalogItem[], region: string | null): LayerCatalogItem[] {
  return layers.filter(l => fits(l, region))
}

/** Включённые оверлеи, уместные в районе кадра; без изменений — тот же массив
 *  (он стоит в зависимостях эффекта рисования). */
export function clampOverlaysToRegion(
  overlays: string[], layers: LayerCatalogItem[], region: string | null,
): string[] {
  const byId = new Map(layers.map(l => [l.id, l]))
  const kept = overlays.filter(id => fits(byId.get(id), region))
  return kept.length === overlays.length ? overlays : kept
}
